import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
export const Ellipsis = styled(Box)(() => `
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    `);
